import { useMemo } from "react";
import TableFilter, { FilterOption } from "."
import { useQuery } from "../../../../../hooks";
import HomeDashboardPageQuery from "../../../../../models/home-dashboard-page-query.model";

const PageSizeFilter: React.FC<{ pageSizeOptions: FilterOption[]}> = ({ pageSizeOptions }) => {
    const [query] = useQuery<HomeDashboardPageQuery>();

    const initial = useMemo<FilterOption>(() => {
        switch(query?.pageSize?.toString()){
            case "15":
                return pageSizeOptions[1];
            case "25":
                return pageSizeOptions[2];
            default:
                return pageSizeOptions[0];
        }
    }, [pageSizeOptions, query]);

    return (
        <TableFilter 
            label={'page-size'} 
            options={pageSizeOptions} 
            initial={initial}
        />
    );
};

export default PageSizeFilter;